import Hero, {
    HeroLayoutProps
} from "@/libraries/design/patterns/hero/src/hero";
import { useLocalizedHref } from "@/libraries/web-framework";

export type UniformHeroSectionProps = {
    heading: string;
    subheading?: string;
    backgroundColor?: string;
    layout?: HeroLayoutProps;
    buttonHref?: {
        path: string;
    };
    buttonLabel?: string;
    imageUrl?: string;
    imageAlt?: string;
    secondaryImageUrl?: string;
};

const UniformHeroSection = (props: UniformHeroSectionProps) => {
    const localizedButtonHref = useLocalizedHref(props.buttonHref?.path ?? "");

    return (
        <Hero
            heading={props.heading}
            subheading={props.subheading}
            layout={props.layout ?? "image-right"}
            // @ts-ignore
            backgroundColor={props.backgroundColor}
            callToActionProps={
                props.buttonHref && props.buttonLabel
                    ? {
                          text: props.buttonLabel,
                          href: localizedButtonHref
                      }
                    : undefined
            }
            imageProps={
                props.imageUrl
                    ? {
                          src: props.imageUrl,
                          alt: props.imageAlt ?? ""
                      }
                    : undefined
            }
            secondaryImageProps={
                props.secondaryImageUrl
                    ? {
                          src: props.secondaryImageUrl,
                          alt: ""
                      }
                    : undefined
            }
        />
    );
};

export default UniformHeroSection;
